import { Component, Input, OnInit } from '@angular/core';
import { CarFilterOptions } from 'src/app/models/car-filter-options.model';
import { Car } from 'src/app/models/car.model';
import { ComponentStatus } from 'src/app/models/component-status.model';
import { DifferenceType } from 'src/app/shared/enums/difference-type.enum';
import {MatCard, MatCardTitle} from "@angular/material/card";
import {TranslateModule} from "@ngx-translate/core";
import {ComponentStatusCssClassPipe} from "../../../pipes/component-status-css-class/component-status-css-class.pipe";
import {DeltaValueOfAnglePipe} from "../../../pipes/delta-value-of-angle/delta-value-of-angle.pipe";
import {DecimalPipe, NgClass, NgStyle} from "@angular/common";
import {MatTableModule} from "@angular/material/table";
import {LabelChartType} from "../../../shared/pipes/label-chart-type.pipe";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'colimo-car-report-bumper-statistics',
  templateUrl: './car-report-bumper-statistics.component.html',
  styleUrls: ['./car-report-bumper-statistics.component.scss'],
  imports: [
    MatCard,
    MatCardTitle,
    TranslateModule,
    ComponentStatusCssClassPipe,
    DeltaValueOfAnglePipe,
    DecimalPipe,
    MatTableModule,
    MatIcon,
    NgClass,
    LabelChartType,
    NgStyle
  ]
})
export class CarReportBumperStatisticsComponent implements OnInit {
  @Input() public car: Car;
  @Input() public filterOptions: CarFilterOptions;
  @Input() public selectedComponentStatus: ComponentStatus;
  @Input() public componentTranslations: string[];
  @Input() public positionTranslations: string[];

  public availableAngles: string[];
  public differenceType: DifferenceType;
  public displayedColumns: string[];
  public displayedColumnsDE: string[];
  constructor() {}

  public ngOnInit(): void {
    this.setAvailableAngles();
    this.setDisplayedColumns();
    this.setDifferenceType();
  }

  private setAvailableAngles(): void {
    let listOfAngles: string[] = [];
    this.car.bumperStatus.forEach((bumperStatus: ComponentStatus) => {
      listOfAngles = listOfAngles.concat(bumperStatus.deltaValues.map((de) => de.angle.toString()));
    });
    this.availableAngles = Array.from(new Set<string>(listOfAngles));
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = ['index', 'component', 'position', 'status'];
    this.displayedColumns = this.displayedColumns.concat(this.availableAngles);
    this.displayedColumnsDE = ['span', 'dE'];
  }

  private setDifferenceType(): void {
    if (this.filterOptions.tolerancesOn) {
      this.differenceType = DifferenceType.S_DE;
    } else {
      this.differenceType = DifferenceType.D_DE;
    }
  }
}
